
const defineSlots = () => {

  const startX = 10
  const startY = 10
  const textHeight = 36

  return [
    [
      {
        "image": {
          "label": "Perimeter Cabinets",
          "x": startX,
          "y": 130,
          "width": 160,
          "height": 256
        },
        "text": {
          "label": "Perimeter Cab Verbiage",
          "x": startX,
          "y": 390,
          "width": 145,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Cabinet Hardware",
          "x": 130,
          "y": 130,
          "width": 100,
          "height": 90
        },
        "text": {
          "label": "Cabinet Hardware Verbiage",
          "x": 175,
          "y": 224,
          "width": 160,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Island Cabinets",
          "x": 150,
          "y": 312,
          "width": 132,
          "height": 140
        },
        "text": {
          "label": "Island Cab Verbiage",
          "x": 175,
          "y": 273,
          "width": 162,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Backsplash Tile",
          "x": 10,
          "y": 480,
          "width": 270,
          "height": 152
        },
        "text": {
          "label": "Backsplash Tile Verbiage",
          "x": 10,
          "y": 636,
          "width": 200,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "3-D Cabinet Drawing",
          "x": 340,
          "y": startY,
          "width": 400,
          "height": 370
        },
        "text": false
      },
      {
        "image": {
          "label": "Lighting (Pendant)",
          "x": 773,
          "y": 48,
          "width": 135,
          "height": 197
        },
        "text": {
          "label": "Lighting Verbiage",
          "x": 918,
          "y": 191,
          "width": 100,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Interior Wall Color",
          "x": 823,
          "y": 252,
          "width": 250,
          "height": 250
        },
        "text": {
          "label": "Interior Color Verbiage",
          "x": 721,
          "y": 446,
          "width": 100,
          "height": textHeight,
          "align": "right",
        }
      },
      {
        "image": {
          "label": "Interior Trim Color",
          "x": 770,
          "y": 297,
          "width": 145,
          "height": 145
        },
      },
      {
        "image": {
          "label": "Faucet",
          "x": 540,
          "y": 349,
          "width": 137,
          "height": 252
        },
        "text": {
          "label": 'Faucet verbiage',
          "x": 679,
          "y": 541,
          "width": 95,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Countertop",
          "x": 289,
          "y": 409,
          "width": 271,
          "height": 271
        },
        "text": {
          "label": 'Countertop verbiage',
          "x": 289,
          "y": 684,
          "width": 136,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Sink",
          "x": 429,
          "y": 615,
          "width": 318,
          "height": 167
        },
        "text": {
          "label": 'Sink verbiage',
          "x": 462,
          "y": 783,
          "width": 127,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Hardwood or LVP Flooring",
          "x": 808,
          "y": 519,
          "width": 265,
          "height": 269
        },
        "text": {
          "label": 'Hardwood verbiage',
          "x": 808,
          "y": 789,
          "width": 265,
          "height": textHeight
        }
      }
    ],
    [
      {
        "image": {
          "label": "Cabinets",
          "x": startX,
          "y": 127,
          "width": 192,
          "height": 287
        },
        "text": {
          "label": "Cabinet Verbiage",
          "x": startX,
          "y": 420,
          "width": 135,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Cabinet Hardware",
          "x": 135,
          "y": 126,
          "width": 100,
          "height": 92
        },
        "text": {
          "label": "Cabinet Hardware Verbiage",
          "x": 204,
          "y": 220,
          "width": 120,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Vanity Light",
          "x": 384,
          "y": 38,
          "width": 277,
          "height": 114
        },
        "text": {
          "label": "Vanity Light Verbiage",
          "x": 384,
          "y": 155,
          "width": 160,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Shower Wall Tile",
          "x": 485,
          "y": 397,
          "width": 268,
          "height": 181
        },
        "text": {
          "label": "Shower Wall Tile Verbiage",
          "x": 485,
          "y": 581,
          "width": 200,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Vanity Elevation",
          "x": 340,
          "y": 194,
          "width": 362,
          "height": 162
        },
        "text": {
          "label": "Vanity Lights",
          "x": 340,
          "y": 359,
          "width": 135,
          "height": (textHeight/2)
        }
      },
      {
        "image": {
          "label": "Interior Wall Color",
          "x": 832,
          "y": 110,
          "width": 244,
          "height": 250
        }
      },
      {
        "image": {
          "label": "Interior Trim Color",
          "x": 778,
          "y": 153,
          "width": 140,
          "height": 143
        },
        "text": {
          "label": "Paint Verbiage",
          "x": 727,
          "y": 302,
          "width": 100,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Faucet",
          "x": 219,
          "y": 600,
          "width": 219,
          "height": 171
        },
        "text": {
          "label": 'Faucet verbiage',
          "x": 373,
          "y": 774,
          "width": 95,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Countertop",
          "x": 154,
          "y": 382,
          "width": 210,
          "height": 210
        },
        "text": {
          "label": 'Countertop verbiage',
          "x": 69,
          "y": 595,
          "width": 140,
          "height": textHeight,
          "align": "right"
        }
      },
      {
        "image": {
          "label": "Shower Floor",
          "x": 544,
          "y": 620,
          "width": 209,
          "height": 183
        },
        "text": {
          "label": 'Shower Floor Verbiage',
          "x": 544,
          "y": 807,
          "width": 160,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Hardwood or LVP Flooring",
          "x": 766,
          "y": 399,
          "width": 317,
          "height": 341
        },
        "text": {
          "label": 'Hardwood verbiage',
          "x": 766,
          "y": 743,
          "width": 160,
          "height": textHeight
        }
      }
    ],
    [
      {
        "image": {
          "label": "Cabinets",
          "x": startX,
          "y": 127,
          "width": 192,
          "height": 287
        },
        "text": {
          "label": "Cabinet Verbiage",
          "x": startX,
          "y": 420,
          "width": 135,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Cabinet Hardware",
          "x": 135,
          "y": 126,
          "width": 100,
          "height": 92
        },
        "text": {
          "label": "Cabinet Hardware Verbiage",
          "x": 204,
          "y": 220,
          "width": 100,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Vanity Light",
          "x": 264,
          "y": 18,
          "width": 277,
          "height": 114
        },
        "text": {
          "label": "Vanity Light Verbiage",
          "x": 264,
          "y": 136,
          "width": 160,
          "height": (textHeight/2)
        }
      },
      {
        "image": {
          "label": "Faucet",
          "x": 316,
          "y": 157,
          "width": 220,
          "height": 168
        },
        "text": {
          "label": 'Faucet verbiage',
          "x": 433,
          "y": 332,
          "width": 100,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Shower Wall Tile",
          "x": startX,
          "y": 512,
          "width": 220,
          "height": 148
        },
        "text": {
          "label": "Shower Wall Tile Verbiage",
          "x": startX,
          "y": 664,
          "width": 200,
          "height": textHeight
        }
      },
      {
        "image": {
          "label": "Countertop",
          "x": 166,
          "y": 330,
          "width": 261,
          "height": 176
        },
        "text": {
          "label": 'Countertop verbiage',
          "x": 434,
          "y": 451,
          "width": 140,
          "height": textHeight,
        }
      },
      {
        "image": {
          "label": "LVP or Tile Flooring",
          "x": 267,
          "y": 512,
          "width": 267,
          "height": 256
        },
        "text": {
          "label": 'Flooring verbiage',
          "x": 375,
          "y": 773,
          "width": 160,
          "height": textHeight,
          "align": "right"

        }
      }
    ],
  ]
}

const slots = defineSlots()

export default slots